import React from "react";
import {
  addBreadcrumb,
  getLastCapturedRequestId,
  reportFrontendError,
} from "../../utils/errorReporter.js";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, requestId: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const requestId = getLastCapturedRequestId();
    addBreadcrumb("react_boundary_fallback", { requestId });
    reportFrontendError({
      error,
      metadata: {
        type: "react_error_boundary",
        componentStack: errorInfo.componentStack,
        requestId,
      },
    });
    this.setState({ requestId: requestId || "" });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#f9fafb",
            padding: "1.5rem",
          }}
        >
          <div
            style={{
              width: "min(38rem, 100%)",
              background: "#ffffff",
              border: "1px solid #e5e7eb",
              borderRadius: "0.8rem",
              padding: "1.3rem",
              boxShadow: "0 6px 20px rgba(15, 23, 42, 0.08)",
            }}
          >
            <h2 style={{ fontSize: "1.2rem", color: "#1f2937", marginBottom: "0.5rem" }}>
              Something went wrong
            </h2>
            <p style={{ fontSize: "0.92rem", color: "#4b5563", lineHeight: 1.5 }}>
              The issue was reported automatically. Try reloading the page.
            </p>
            {this.state.requestId ? (
              <p
                style={{
                  marginTop: "0.65rem",
                  fontSize: "0.8rem",
                  color: "#475569",
                  fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
                }}
              >
                requestId: {this.state.requestId}
              </p>
            ) : null}
            <button
              onClick={() => window.location.reload()}
              style={{
                marginTop: "1rem",
                border: "none",
                borderRadius: "0.45rem",
                background: "#1b3c53",
                color: "#fff",
                fontWeight: 600,
                padding: "0.6rem 0.95rem",
                cursor: "pointer",
              }}
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
